import { useRef, useEffect, useCallback } from 'react';
import { gtmEventType, inquiryType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import ListingGridImage from '@Components/Listings/ListingGridImage.jsx'
import ready from 'document-ready';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const EmptyLegListing = (props) => {
    const ref = useRef();
    const windowSize = useWindowSize();

    useEffect(() => {
        ready(() => {
            setTimeout(() => {
                adjustElementHeightsByRow('list-seller');
                adjustElementHeightsByRow('list-title');
            }, 0);
        });
    }, []);

    useEffect(() => {
        adjustElementHeightsByRow('list-seller');
        adjustElementHeightsByRow('list-title');
    }, [windowSize.width, props.searchData]);

    const adjustElementHeightsByRow = useCallback((className) => {
        const elements = document.querySelectorAll(`.${className}`);
        if (!elements.length) return;
        const itemsPerRow = windowSize.width > 1250 ? 4 : windowSize.width > 1000 ? 2 : 1;
        const rows = [];
        let currentRow = [];

        const elementData = Array.from(elements).map((element, index) => {
            element.style.height = "";

            currentRow.push(element);

            if ((index + 1) % itemsPerRow === 0 || index === elements.length - 1) {
                rows.push([...currentRow]);
                currentRow = [];
            }

            return {
                element,
                height: element.getBoundingClientRect().height // More accurate than clientHeight
            };
        });

        requestAnimationFrame(() => {
            let elementIndex = 0;

            rows.forEach(row => {
                const rowElements = elementData.slice(elementIndex, elementIndex + row.length);
                const maxHeight = Math.max(...rowElements.map(data => data.height));

                rowElements.forEach(data => {
                    data.element.style.height = `${maxHeight}px`;
                });

                elementIndex += row.length;
            });
        });
    }, [windowSize.width]);

    const openEmptyLegQuoteModal = () => props.openEmptyLegQuoteModal({
        EmptyLegListingID: props.EmptyLegListingID,
        DepartureFromField: props.DepartureFromField,
        DepartureFromCityField: props.DepartureFromCityField,
        DepartureFromCountryID: props.DepartureFromCountryIDField,
        DepartureToCountryID: props.DepartureToCountryIDField,
        DepartureFromStateField: props.DepartureFromStateField,
        DepartureToField: props.DepartureToField,
        DepartureToCityField: props.DepartureToCityField,
        DepartureToStateField: props.DepartureToStateField,
        departingDate: props.DepartureDateTimeField,
        ref: ref,
        AircraftDescription: props.AircraftDescriptionField,
        Phone: props.Phone
    });

    const formatDate = (dateString) => {
        const options = {
            month: 'short',
            day: 'numeric'
        };
        return new Date(dateString).toLocaleDateString('en-US', options);
    };

    return (
        <>
            <div className="empty-leg-listing">
                <div className="list-date">
                    {formatDate(props.DepartureDateTimeField)}
                </div>
                <div className="list-details">
                    <div className="list-media">
                        {!props.NoImageRow &&
                            <div className={'image-container' + (props.MediaModel.Media.length > 0 ? '' : ' no-media')}>
                                {props.MediaModel.Media.length > 0 ?
                                    <ListingGridImage ImageUrl={props.MediaModel.Media.map(media => media.MediaUrl)} IsParts={true} />
                                    :
                                    <div className='media-control-no-photo' />
                                }
                            </div>
                        }
                    </div>
                    <div className="list-title">
                        {props.DepartureFromField} <i className="fa-solid fa-right-long"></i> {props.DepartureToField}
                    </div>
                    <div className="list-specs">
                        <div className="list-spec">
                            <i className="fa-solid fa-plane"></i>
                            <span>{props.AircraftDescriptionField.trim().split(" ").pop()}</span>
                        </div>
                        <div className="list-spec">
                            <i className="fa-solid fa-users"></i>
                            <span>{props.NumberOfPassengersField} {translator.translate('sandhills.seats')}</span>
                        </div>
                        <div className="list-spec">
                            <a href={"tel:" + props.AccountPhone}>
                                <i className="fa-solid fa-phone"></i>
                                <span>{translator.translate('sandhills.call')}</span>
                            </a>
                        </div>
                    </div>
                    <a className="ts-button block-btn quote-btn" onClick={openEmptyLegQuoteModal}><i className="fa-solid fa-file-invoice-dollar fa-icon"></i> <TranslationText tKey='sandhills.requestaquote' /></a>
                    <div className="list-seller">
                        {props.AccountName &&
                            <div className="text-wrapper">
                                <strong>{translator.translate('sandhills.tradepubwebsite.mvc.company')}: </strong>
                                {props.CompanyWebsite ?
                                    <a href={props.CompanyWebsite} className='dealer-name-link' target='_blank' aria-label={props.AccountName + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                                        <span className='dealer-name' >{props.AccountName}</span>
                                    </a>
                                    :
                                    <strong>{props.AccountName}</strong>}
                            </div>}
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmptyLegListing;